import BrandColors from "../../../../styles/BrandColors";
const { JLLBrandColors } = BrandColors;

export default (theme) => ({
  pageHeader: {
    padding: "74px 20px 20px 20px",
    marginLeft: 220,
    minHeight: 185,
    boxSizing: "border-box",
    borderBottom: "1px solid #cac5c5d9",
    //boxShadow: "0px 2px 4px #e4e4e4",
    borderLeft: "1px solid #d6d6d6f7",
  },
  link: {
    //paddingTop: 10,
    cursor: 'pointer',
    color: JLLBrandColors.Red.core
  }
});
